import { load } from 'webfontloader';

load({
  // typekit: {
  //   id: 'uuo1fei'
  // },
  // google: {
  //   families: ['Playfair+Display:400,400i,700', 'Lato:300,300i,400,700']
  // },
  custom: {
    families: ['apercu:400,600,900']
    // urls: ["{{ '~assets/webfonts.css' | asset_url }}"],
    // urls: ['~assets/webfonts.css'],
  },
  active() {
    // console.log('webfonts loaded');
    // var event = document.createEvent('Event');
    // event.initEvent('webfontsready', true, true);
    // document.dispatchEvent(event);
    // App.emit('webfontsready');
  }
});
